import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { CoreService } from 'app/services/entidades/core.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class RoleService extends CoreService {

  constructor(
    private _http: Http
  ) {
    super(_http);
  }

  /**
   * Retorna los roles del sistema
   * @return {any} Objeto json con los roles del sitema
   */
  get(): Observable<any> {
    return this.getMethod('role/');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/entidades/role.service.ts